import { ItemsList } from "components/ItemsList";

export const RelatedItemsWrapper = ({
  related_items_title,
  related_items,
  withBorderTop = false,
}) => {
  const items = related_items.map((item) => ({
    cropCenter: item.related_item_image_crop_center,
    link: item.related_item_link,
    text: item.related_item_text,
    title: item.related_item_title,
    image: {
      src: item.related_item_image.url,
      alt: item.related_item_image.alt,
    },
  }));

  return (
    <ItemsList
      items={items}
      title={related_items_title}
      withBorderTop={withBorderTop}
      imageSizes={[
        { minWidth: 1024, width: 360, ratio: 1.5 },
        { minWidth: 900, width: 465, ratio: 1.5 },
        { minWidth: 768, width: 400, ratio: 1.5 },
        { minWidth: 700, width: 768, ratio: 1.5 },
        { minWidth: 600, width: 660, ratio: 1.5 },
        { minWidth: 500, width: 560, ratio: 1.5 },
        { minWidth: 400, width: 460, ratio: 1.5 },
        { minWidth: 345, width: 360, ratio: 1.5 },
        { minWidth: 1, width: 305, ratio: 1.5 },
      ]}
    />
  );
};
